import type { Directive } from 'vue';

const preventEnterSubmit: Directive<HTMLFormElement, void> = {
  mounted(el) {
    el.__onKeydown__ = (e: KeyboardEvent) => {
      if (e.key !== 'Enter') return;

      const target = e.target as HTMLElement | null;
      if (!target) return;

      const tag = target.tagName;
      const type = (target as HTMLInputElement).type;

      // allow Enter in fields that should accept it
      const isTextArea = tag === 'TEXTAREA';
      const isContentEditable =
        target.isContentEditable ||
        !!target.closest('.ck-editor, .ck, .ck-content'); // CKEditor containers

      const isButtonOrSubmit =
        tag === 'BUTTON' ||
        (tag === 'INPUT' && (type === 'submit' || type === 'button'));

      if (isTextArea || isContentEditable || isButtonOrSubmit) {
        return; // do NOT block Enter here
      }

      // Optional: also allow Enter when a focused element has data-allow-enter
      if (target.closest('[data-allow-enter]')) return;

      // Block Enter to prevent accidental form submit elsewhere (e.g., inputs)
      e.preventDefault();
    };

    el.addEventListener('keydown', el.__onKeydown__ as EventListener);
  },
  unmounted(el) {
    el.removeEventListener('keydown', el.__onKeydown__ as EventListener);
    delete (el as any).__onKeydown__;
  },
};

export default preventEnterSubmit;